var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCareerEportal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 21V6.75L11.25 0H3C1.34315 0 0 1.34314 0 3V16.5H1.5V3C1.5 2.17157 2.17157 1.5 3 1.5H11.25V4.5C11.25 5.74264 12.2574 6.75 13.5 6.75H16.5V21C16.5 21.8284 15.8284 22.5 15 22.5H7.5V24H15C16.6569 24 18 22.6569 18 21Z",
    fill: "#5C5E69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.03322 18.798C3.44016 17.9905 3.08984 16.9937 3.08984 15.915C3.08984 13.2227 5.27246 11.04 7.96484 11.04C10.6572 11.04 12.8398 13.2227 12.8398 15.915C12.8398 18.6074 10.6572 20.79 7.96484 20.79C6.88591 20.79 5.88883 20.4395 5.08128 19.8462L5.08193 19.8467C5.05981 19.8767 5.03517 19.9054 5.00802 19.9325L2.12017 22.8204C1.82728 23.1133 1.35241 23.1133 1.05951 22.8204C0.76662 22.5275 0.76662 22.0526 1.05951 21.7597L3.94736 18.8719C3.97451 18.8447 4.00323 18.8201 4.03322 18.798ZM3.83984 15.915C3.83984 18.1932 5.68667 20.04 7.96484 20.04C10.243 20.04 12.0898 18.1932 12.0898 15.915C12.0898 13.6369 10.243 11.79 7.96484 11.79C5.68667 11.79 3.83984 13.6369 3.83984 15.915Z",
    fill: "#5C5E69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareerEportal);
export default __webpack_public_path__ + "static/media/career-eportal.4e288cb1b250ef1f48505511b304487c.svg";
export { ForwardRef as ReactComponent };